import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'upperCase',
  standalone: true
})
export class UpperCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    const initials = value.charAt(0).toUpperCase() + value.slice(1);
    return initials;
  }

}
